import dynamic from 'next/dynamic';
import { useEffect, useRef, useState } from 'react';
import 'leaflet/dist/leaflet.css';

const ShowDetailMap = ({ lat, lng, image }) => {
    const mapRef = useRef(null);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true);
    }, []);

    useEffect(() => {
        if (!isClient || !window || mapRef.current) return;

        import('leaflet').then((L) => {
            mapRef.current = L.map('map', {
                center: [lat || 51.505, lng || -0.09],
                zoom: 13,
            });

            L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap contributors',
            }).addTo(mapRef.current);

            const svgIcon = L.divIcon({
                className: 'svg-marker',
                html: `<svg class="marker-svg" viewBox="0 0 68 81" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fillRule="evenodd" clipRule="evenodd" d="M38.9617 72.5484C41.1138 68.8209 44.7631 66.2853 48.6372 64.4099C59.9658 58.9256 67.7785 47.3198 67.7785 33.8893C67.7785 15.1727 52.6058 0 33.8893 0C15.1727 0 0 15.1727 0 33.8893C0 47.32 7.81296 58.926 19.1418 64.4101C23.0161 66.2856 26.6656 68.8211 28.8178 72.5488L33.0236 79.8335C33.4085 80.5002 34.3707 80.5002 34.7556 79.8335L38.9617 72.5484Z" fill="#FA2CB4"/>
                        </svg>`,
                iconSize: [60, 60],
                iconAnchor: [25, 70],
                popupAnchor: [0, -70],
            });

            const mainMarker = L.marker([lat || 51.505, lng || -0.09], { icon: svgIcon })
                .addTo(mapRef.current)
                .bindPopup('<b>Show Here!</b>');

            mainMarker.on('click', () => {
                const gmapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                window.open(gmapUrl, '_blank');
            });

            const photoUrl = image || '/placeholder.jpg';
            const photo = L.divIcon({
                className: 'photo-marker',
                html: `<img src="${photoUrl}" alt="photo-marker" class="photo-marker-img" style=" border-radius: 50%; border: 2px solid #fff;" />`,
                iconSize: [50, 50],
                iconAnchor: [18, 38],
            });

            const photoMarker = L.marker([lat || 51.505, lng || -0.09], { icon: photo }).addTo(mapRef.current);

            photoMarker.on('click', () => {
                const gmapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
                window.open(gmapUrl, '_blank');
            });
        });

        return () => {
            if (mapRef.current) {
                mapRef.current.remove();
                mapRef.current = null;
            }
        };
    }, [isClient, lat, lng, image]);

    if (!isClient) return <div className="w-full h-60 bg-gray-200">Loading Map...</div>;

    return (
        <div className='showDetailMap w-full'>
            <div
                id="map"
                style={{
                    height: '270px',
                    width: '100%',
                    maxWidth: '600px',
                }}
                className='max-w-[600px] w-full max-h-[149px] md:max-h-[270px] h-full'
            ></div>
        </div>
    );
};

export default dynamic(() => Promise.resolve(ShowDetailMap), { ssr: false });